import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiClient, formatApiError } from "../api/client";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError(null);
    setSubmitting(true);
    try {
      await apiClient.post("/auth/forgot-password", {
        email: email.trim().toLowerCase(),
      });
      // Anti-enumeration: always show the same generic confirmation.
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-md py-12" data-testid="forgot-password-page">
      <div className="rounded-3xl border border-zinc-800 bg-zinc-900/40 p-8 space-y-5">
        <header className="space-y-2">
          <h1 className="text-2xl font-semibold text-zinc-100">Passwort vergessen?</h1>
          <p className="text-sm text-zinc-400 leading-relaxed">
            Gib deine E-Mail-Adresse ein. Wir senden dir einen Link, mit dem du dein
            Passwort zurücksetzen kannst.
          </p>
        </header>

        {done ? (
          <div
            data-testid="forgot-password-success"
            className="rounded-md border border-emerald-500/40 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-200"
          >
            Wenn ein Konto mit dieser E-Mail existiert, haben wir dir eine E-Mail zum
            Zurücksetzen gesendet. Prüfe auch deinen Spam-Ordner.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-password-form">
            <div className="space-y-1.5">
              <label
                htmlFor="forgot-email"
                className="text-xs uppercase tracking-[0.18em] text-zinc-500"
              >
                E-Mail
              </label>
              <input
                id="forgot-email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-password-email-input"
                placeholder="deine@email.com"
                className="w-full rounded-md border border-zinc-800 bg-zinc-950 px-3 py-2 text-sm text-zinc-100 placeholder-zinc-500 focus:border-emerald-500 focus:outline-none"
              />
            </div>

            {error && (
              <div
                data-testid="forgot-password-error"
                className="rounded-md border border-rose-900 bg-rose-950/40 px-3 py-2 text-sm text-rose-300"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={submitting}
              data-testid="forgot-password-submit"
              className="w-full rounded-md bg-emerald-500 px-4 py-2.5 text-sm font-medium text-zinc-950 transition-colors hover:bg-emerald-400 disabled:opacity-60"
            >
              {submitting ? "Sende …" : "Reset-Link senden"}
            </button>
          </form>
        )}

        <div className="pt-2 text-center text-xs text-zinc-500">
          <Link
            to="/login"
            data-testid="forgot-password-back-to-login"
            className="hover:text-zinc-300 underline-offset-4 hover:underline"
          >
            Zurück zum Login
          </Link>
        </div>
      </div>
    </div>
  );
}
